export const ERROR_BAD_MAC = 'Bad MAC';
//# sourceMappingURL=error.js.map